// client/src/components/GroupIcons.js
import bil        from '../assets/icons/1bil-ikon.png';
import henger     from '../assets/icons/2henger-ikon.png';
import teltfest   from '../assets/icons/3teltfest-ikon.png';
import flytting   from '../assets/icons/4flytting-ikon.png';
import verktoy    from '../assets/icons/5verktoey-ikon.png';
import lager      from '../assets/icons/6lager-ikon.png';

export const groupIcons = {
  bil,
  henger,
  // støtt begge varianter av slug:
  teltogfest: teltfest,
  teltfest:   teltfest,
  flytting,
  verktoy,
  lager,
};
